import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DropdownOptions from "../../../constants/DropdownOptions";
import * as farmActions from "../../../modules/farmManagement/action";
import "../../../style";
import { formatDate } from "../../../utils/DateFormatter";
import TabHeaderAndButton from "../../Common/TabHeaderAndButton";
import CreateTable from "../../CreateTable";
import Loader from "../../Loader";




class FarmManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        updatedAt: "Last Updated",
        farmName: "Sub-Farm Name",
        farmId: "Sub-Farm Id",
        address: "Address",
        farmSize: "Farm Size"
      },
      MainFarmheaderRows: {
        updatedAt: "Last Updated",
        farmName: "Main Farm Name",
        farmId: "Main Farm Id",
        address: "Address",
        farmSize: "Farm Size"
      },
      order: "desc",
      orderBy: "id"
    };
  }
  componentDidMount() {
    if(this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
      this.props.actions.getAllSubFarmsList(this.props.MainFarmId);
    } 
     else {  
        this.props.actions.getAllMainFarmsList();
     }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.FarmsList && nextProps.MainFarmsList &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
  }

  createRowData = rowData => {
    rowData= rowData.filter(value => value.id !="farmMgmtLink")
    return Object.keys(rowData).map(value => {
      let CurrentRow = rowData[value];
      let obj = {};
      var date = new Date(CurrentRow.updatedAt);
      obj["updatedAt"] = formatDate(date);
      obj["farmName"] = CurrentRow.farmName;
      obj["farmId"] = CurrentRow.farmId;
      obj["address"] = CurrentRow.address;
      obj["farmSize"] = CurrentRow.farmSize;
      obj["id"] = CurrentRow.id;
      obj["disabled"] = CurrentRow.disable ? CurrentRow.disable : false;
      return obj;
    });
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };
  deleteRow = id => {
    //this.props.actions.deleteContract(id);
  };

  editRow = id => {
    const { FarmsList , MainFarmsList } = this.props;
    const requiredData = FarmsList.find(farm => farm.id === id);
    const MainFarmData = MainFarmsList.find(farm => farm.id === id);
    if(this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id){
        this.props.actions.MainfarmEditAction(MainFarmData);
    }
    else {
        this.props.actions.farmEditAction(requiredData);
    }
  };

  render() {
    const { fetchingComplete, order, orderBy } = this.state;
    const { FarmsList, ErrorMessage, MainFarmsList } = this.props;
    const prevPath = "subFarmsList";
    const MainFarmPath = "farmmanagement";
    return (
      <div className="ticket-body">
        {this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
        <div>
          {fetchingComplete ? (
            ErrorMessage && ErrorMessage.message ? (
              <div className="ErrorMessage">{ErrorMessage.message}</div>
            ) : (
                <div>
                <TabHeaderAndButton
                     header="MAIN FARM"
                     path="/farmmanagement/createmainfarm"
                     btnLabel="Create Main farm"
                />
              <CreateTable
                orderBy={orderBy}
                order={order}
                onRequestSort={this.handleRequestSort}
                headerRows={this.state.MainFarmheaderRows}
                rowData={this.createRowData(MainFarmsList)}
                location={`${MainFarmPath}/edit`}
                //delete={this.deleteRow}
                edit={this.editRow}
                isMenuRequired={false}
              />
              </div>
            )
          ) : (
            <Loader />
          )}
        </div>
        ):(
            <div>
          {fetchingComplete ? (
            ErrorMessage && ErrorMessage.message ? (
              <div className="ErrorMessage">{ErrorMessage.message}</div>
            ) : (
                <div>
                <TabHeaderAndButton
                    header="Farms"
                    path="/farmmanagement/createsubfarm"
                    btnLabel="Create Sub farm"
                />
              <CreateTable
                orderBy={orderBy}
                order={order}
                onRequestSort={this.handleRequestSort}
                headerRows={this.state.headerRows}
                rowData={this.createRowData(FarmsList)}
                location={`${prevPath}/edit`}
                //delete={this.deleteRow}
                edit={this.editRow}
              />
              </div>
            )
          ) : (
            <Loader />
          )}
        </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    user: state.user,
    FarmsList: state.FarmManagementReducer.FarmsList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    MainFarmsList: state.FarmManagementReducer.MainFarmsList
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...farmActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FarmManagement);



// WEBPACK FOOTER //
// ./src/components/private/FarmManagment/FarmManagement.js